export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      advancedSearchExpanded: false
    }
  },
  methods: {
    handleAdvancedSearchExpanded(expanded) {
      const refComp = this.$refs.refAdvancedSearch
      if (refComp.fieldsList.length === 0) { // 如果没有数据的话点击展开就需要去查询
        refComp.loading = true
      }
      this.advancedSearchExpanded = expanded
      // 传 loading 区分是否需要调接口
      this.$emit('advanced-search-expand-change', { expanded, loading: refComp.loading })
    },
    // 设置字段list
    advancedSearchSetFieldsList(list) {
      this.$refs.refAdvancedSearch.setFieldsList(list)
    },
    // 设置已保存的template List
    advancedSearchSetTemplateList(list, isInit) {
      this.$refs.refAdvancedSearch.setTemplateList(list, isInit)
    },
    // 点击template查询queryList赋值
    advancedSearchSetQueryList(list) {
      this.$refs.refAdvancedSearch.setQueryList(list)
    },
    // 设置下拉的选项
    advancedSearchSetSelectList(key, value) {
      this.$refs.refAdvancedSearch.setSelectListObj(key, value)
    },
    advancedSearchSetLoading(loading) {
      this.$refs.refAdvancedSearch.loading = loading
    },
    advancedSearchClearAll() {
      this.$refs.refAdvancedSearch.clearQueryData()
    },
    advancedSearchGetQueryList() {
      return this.$refs.refAdvancedSearch.queryList || []
    },
    // 删除保存的template模板
    advancedSearchDeleteTemplate(row) {
      this.$emit('advanced-search-delete-template', row)
    },
    // 保存模板
    advancedSearchSaveTemplate(obj) {
      this.$emit('advanced-search-save-template', obj)
    },
    // 查询
    advancedSearch(data) {
      this.$emit('advanced-search', data)
    },
    // reset重置
    advancedSearchReset(data) {
      this.$emit('advanced-search-reset', data)
    },
    // 点击查询template
    advancedSearchClickTemplate(row) {
      this.$emit('advanced-search-click-template', row)
    },
    // 点击设置默认模板
    advancedSearchSetAsDefaultTemplate(row) {
      this.$emit('advanced-search-set-as-default-template', row)
    },
    // 字段变化后如果是下拉请求下拉接口
    advancedSearchFieldChange(row) {
      this.$emit('advanced-search-field-change', row)
    }
  }
}
